import { mapState } from 'vuex'
import { changeTitleBarMode } from '@/utils/native'

export default {
  data() {
    return {
      noReloadPage: false,
    }
  },
  computed: {
    ...mapState(['isApp']),
  },
  created() {
    if (process.client && this.isApp) {
      // app内详情页隐藏标题栏
      changeTitleBarMode(3)
      // 刷新页面
      // window.addEventListener('pageVisible', this.onPageVisible)
    }
  },
  beforeDestroy() {
    if (this.isApp) {
      // app内详情页展示标题栏
      changeTitleBarMode(0)
      // window.removeEventListener('pageVisible', this.onPageVisible)
    }
  },
  methods: {
    onPageVisible() {
      if (!this.noReloadPage) {
        window.location.reload()
      }
      this.noReloadPage = false
    },
  },
}
